export default function hasPassiveSupport() {
  let passiveSupported = false;
  try {
    const options = {
      get passive() {
        passiveSupported = true;
        return false;
      }
    };
    window.addEventListener('test', () => null, options);
    window.removeEventListener('test', () => null, options);
  } catch (err) {
    passiveSupported = false;
  }
  return passiveSupported;
}
export const passiveIfSupported = hasPassiveSupport() ? {
  passive: true
} : false;